import { render } from "./HeroiconsOutlineChevronDoubleRight.vue?vue&type=template&id=fd287528"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronDoubleRight.vue"]])

export default __exports__